import * as React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Button, Box, styled } from "@mui/material";
import logo from "./assets/DIGI-PASS-LOGO.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface Props {
  window?: () => Window;
}

const drawerWidth = 260;
const navItems = [
  { text: "Home", link: "/" },
  { text: "About", link: "/about-us" },
  { text: "Appointment", link: "/appointment" },
  { text: "Track Appointment", link: "/track-appointment" },

  { text: "Contact", link: "/contact-us" },
  // { text: "Login", link: "/admin" },
];

const AppBarWithBluePart = styled(AppBar)({
  background: "white",
  boxShadow: "none",
  // height: "74px",
});

const Logo = styled("img")({
  width: 230,
  marginLeft: "20px",
});

const MenuItems = styled("div")({
  float: "right",
  "& a": {
    color: "#1E1E1E",
    fontWeight: 400,
    textDecoration: "none",
    fontSize: "17px",
    marginLeft: "1.5rem",
    position: "relative",
    "&:hover": {
      "&::before": {
        content: "''",
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "-2px",
        height: "3px",
        background: "#107de2",
      },
    },
  },
});

const LogoBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  paddingRight: "3rem",
  maxWidth: "220px",
});

const BluePart = styled("div")({
  position: "absolute",
  top: 0,
  right: 0,
  height: "100%",
  maxWidth: 200,
  background: "blue",
  display: "flex",
  alignItems: "center",
  padding: "1.5rem",
});

const LoginButton = styled(Button)({
  color: "white",
  fontSize: "16px",
  padding: "0 1.5rem",
  fontFamily: "Open Sans, sans-serif",
});

export default function DrawerAppBar(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center", marginTop: "0px" }}
    >
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              sx={{
                textAlign: "left",
              }}
            >
              <Link
                to={item.link}
                style={{
                  textDecoration: "none",
                  color: "#1E1E1E",
                  fontWeight: 400,
                }}
              >
                <ListItemText
                  primary={item.text}
                  sx={{
                    "&:hover": {
                      borderBottom: "2px solid blue",
                    },
                  }}
                />
              </Link>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex", marginTop: "auto" }}>
      <CssBaseline />
      <AppBarWithBluePart position="static">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <LogoBox component={Link} to="/">
            <Logo src={logo} alt="Logo" />
          </LogoBox>
          <Box
            sx={{
              display: { xs: "none", sm: "block" },
              flexGrow: 1,
              justifyContent: "flex-end",
              marginRight: "4.5rem",
            }}
          >
            <MenuItems>
              <Button component={Link} to="/">
                Home
              </Button>
              <Button component={Link} to="/about-us">
                About
              </Button>
              <Button component={Link} to="/appointment">
                Appointment
              </Button>
              <Button component={Link} to="/track-appointment">
                Track Appointment
              </Button>

              <Button component={Link} to="/contact-us">
                Contact
              </Button>
              <Button component="a" href="/admin">
                Login
              </Button>
            </MenuItems>
            <BluePart>
              <LoginButton
                endIcon={<ArrowForwardIcon />}
                component="a"
                href="/admin"
              >
                Login
              </LoginButton>
            </BluePart>
          </Box>
          <IconButton
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{
              display: { sm: "none" },
              marginRight: "1rem",
              borderRadius: "8px",
              color: "rgba(0,0,0,0.55)",
              transition: "box-shadow 0.15s ease-in-out",
              border: "1px solid rgba(0,0,0,0.1)",
              backgroundColor: "transparent",
              padding: ".25rem .75rem",
              lineHeight: 1,
            }}
          >
            <MenuIcon sx={{ width: "1.5rem", height: "1.75rem" }} />
          </IconButton>
        </Toolbar>
      </AppBarWithBluePart>

      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          //anchor="top" // Set the anchor to "top"
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <LogoBox component="a" href="index.html">
            <Logo src={logo} alt="Logo" />
          </LogoBox>
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}
